import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {NavigationTabsModuleConfig} from "./navigation-tabs-module.config";
import {NavigationTabsModuleState} from "./models/navigation-tabs-module.state";

export class NavigationTabsModuleStore extends BaseMobxStore {
  static injectables = [NavigationTabsModuleConfig, NavigationTabsModuleState];
}
